import { format } from 'date-fns';
const DATE_FORMAT_MMMDYYYY = 'MMM d, yyyy';
export const formatDayAndMonth = (str, max) => {
    let parsedString = str;
    if (parsedString.charAt(0) !== '0' || str === '00') {
        let num = parseInt(parsedString, 10);
        if (Number.isNaN(num) || num <= 0 || num > max)
            num = 1;
        parsedString =
            num > parseInt(max.toString().charAt(0), 10) &&
                num.toString().length === 1
                ? `0${num}`
                : num.toString();
    }
    return parsedString;
};
export const formatDate = (dateString) => {
    const formatDateValue = /\D\/$/.test(dateString)
        ? dateString.substring(0, dateString.length - 2)
        : dateString;
    const values = formatDateValue
        .split('/')
        .map((dateValue) => dateValue.replace(/\D/g, ''));
    if (values[0])
        values[0] = formatDayAndMonth(values[0], 12);
    if (values[1])
        values[1] = formatDayAndMonth(values[1], 31);
    if (values.join('').length > 4) {
        const output = values.map((outputVal, index) => index < 2 ? `${outputVal}/` : outputVal);
        return output.join('').substring(0, 10);
    }
    const dateOutput = values.map((dateVal, index) => dateVal.length === 2 && index < 2 ? `${dateVal}/` : dateVal);
    return dateOutput.join('').substring(0, 10);
};
export const formatDateObject = (date) => {
    const dateWithoutTimezone = new Date(date.valueOf() + date.getTimezoneOffset() * 60000);
    return format(dateWithoutTimezone, DATE_FORMAT_MMMDYYYY);
};
//# sourceMappingURL=index.js.map